import React from "react";
import PropTypes from "prop-types";

const valueType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.bool,
]);

const propTypes = {
  labels: PropTypes.shape({
    left:   PropTypes.shape({ title: PropTypes.string.isRequired, value: valueType }),
    center: PropTypes.shape({ title: PropTypes.string.isRequired, value: valueType }),
    right:  PropTypes.shape({ title: PropTypes.string.isRequired, value: valueType }),
  }),
  onChange: PropTypes.func.isRequired,
  styles: PropTypes.object,
};

const defaultProps = {
  labels: {
    left:   { title: "left",   value: "left" },
    center: { title: "center", value: "center" },
    right:  { title: "right",  value: "right" },
  },
  onChange: (value) => console.info("value:", value),
};

const POSITIONS = ["left", "center", "right"];

const SLIDER_OFFSET = { left: 4, center: 84, right: 164 };

class TripleToggleSwitch extends React.Component {
  constructor(props) {
    super(props);
    this.state = { switchPosition: "left" };
  }

  handleChange = (value) => {
    if (this.props.loadingTransaction) return;
    this.props.onChange(value);
    this.setState({ switchPosition: value });
  };

  getSliderOffset() {
    return SLIDER_OFFSET[this.state.switchPosition] || 4;
  }

  render() {
    const { labels, loadingTransaction } = this.props;
    const { switchPosition } = this.state;

    return (
      <>
        <div className={"tts-root" + (loadingTransaction ? " tts-root--disabled" : "")}>
          {/* Sliding pill */}
          <div
            className="tts-slider"
            style={{ transform: "translateX(" + this.getSliderOffset() + "px)" }}
          />

          {/* Options */}
          {POSITIONS.map(function(pos) {
            return (
              <button
                key={pos}
                type="button"
                disabled={!!loadingTransaction}
                onClick={() => this.handleChange(pos)}
                className={"tts-option" + (switchPosition === pos ? " tts-option--active" : "")}
              >
                {(labels[pos] && labels[pos].title) ? labels[pos].title : pos}
              </button>
            );
          }.bind(this))}
        </div>

        <style>{`
          .tts-root {
            font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
            position: relative;
            display: inline-flex;
            align-items: center;
            width: 240px;
            height: 36px;
            background: #f1f5f9;
            border-radius: 10px;
            border: 1.5px solid #e2e8f0;
            padding: 3px;
            box-sizing: border-box;
          }
          .tts-root--disabled {
            opacity: 0.55;
            pointer-events: none;
            cursor: not-allowed;
          }
          .tts-slider {
            position: absolute;
            top: 3px;
            left: 0;
            width: 76px;
            height: 27.6px;
            background: linear-gradient(135deg, #1d4ed8, #2563eb);
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(37,99,235,0.3);
            transition: transform 0.25s cubic-bezier(0.16,1,0.3,1);
            z-index: 1;
          }
          .tts-option {
            position: relative;
            z-index: 2;
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
            font-size: 12.5px;
            font-weight: 600;
            color: #64748b;
            background: none;
            border: none;
            cursor: pointer;
            border-radius: 7px;
            transition: color 0.2s;
            user-select: none;
          }
          .tts-option--active {
            color: #fff;
          }
          .tts-option:not(.tts-option--active):hover {
            color: #0f172a;
          }
        `}</style>
      </>
    );
  }
}

TripleToggleSwitch.propTypes = propTypes;
TripleToggleSwitch.defaultProps = defaultProps;

export default TripleToggleSwitch;